// Upstream OpenLifter WRPF (international) preset — preserve alongside WRPF Argentina.

export const WRPF_INTERNATIONAL_DIVISIONS = [
  "J8-9",
  "J10-11",
  "J12-13",
  "J14-16",
  "J17-19",
  "J20-23",
  "Open",
  "S35-39",
  "M40-44",
  "M45-49",
  "M50-54",
  "M55-59",
  "M60-64",
  "M65-69",
  "M70-74",
  "M75-79",
  "M80+",
] as const;

export const WRPF_INTERNATIONAL_WEIGHT_MEN = [52, 56, 60, 67.5, 75, 82.5, 90, 100, 110, 125, 140] as const;

export const WRPF_INTERNATIONAL_WEIGHT_WOMEN = [44, 48, 52, 56, 60, 67.5, 75, 82.5, 90, 100, 110, 125, 140] as const;

export const wrpfInternationalMeetDefaults = {
  divisions: [...WRPF_INTERNATIONAL_DIVISIONS],
  weightClassesKgMen: [...WRPF_INTERNATIONAL_WEIGHT_MEN],
  weightClassesKgWomen: [...WRPF_INTERNATIONAL_WEIGHT_WOMEN],
  weightClassesKgMx: [...WRPF_INTERNATIONAL_WEIGHT_MEN],
  formula: "Wilks" as const,
  ageCoefficients: "FosterMcCulloch" as const,
  wrapsOnlyAffectSquat: false,
  combineSleevesAndWraps: false,
  combineSingleAndMulti: false,
  allow4thAttempts: true,
};
